
import { Component, Vue, Prop } from "vue-property-decorator";
@Component({
  components: {}
})
export default class QuestionItem extends Vue {
  @Prop({ required: true }) private item!: any;
}
